import { useState } from 'react';
import { ArrowLeft } from '@hungryroot/icons';
import { Button } from '@hungryroot/ramen';
import { TextSection } from '../../components/TextSection/TextSection';
import { ControlRadioGroup } from '../../Controls/ControlRadioGroup/ControlRadioGroup';
import { useCancelReasons } from '../../hooks/useGetCancelReasons';
import pageStyles from '../page.module.css';

interface Props {
  testid?: string;
  onNext: (value?: {
    cancelReasonId: number[];
    cancelReasonText: string | null;
    cancelFreeTextHeader: string | null;
  }) => void;
  onPrev: () => void;
}

export function PrimaryReason(props: Props) {
  const { testid, onNext, onPrev } = props;
  const [value, setValue] = useState<number | null>(null);

  const { data: cancelReasons } = useCancelReasons();

  return (
    <div data-testid={testid} className={pageStyles.container}>
      <Button
        onClick={onPrev}
        style="default"
        testid={`${testid}-prev`}
        size="medium"
        prominence="tertiary"
        icon={<ArrowLeft />}
        iconPosition="left"
        textPrimary="Back"
        className={pageStyles.back}
      />
      <TextSection
        testid={`${testid}-text-section`}
        heading="Why do you want to go?"
        body="Understanding why you’d like to cancel helps us improve. (Especially because we’d love to welcome you back someday.) Select the reason you’d like to cancel and continue:"
        className={pageStyles.text}
      />
      <div className={pageStyles.content}>
        <div className={pageStyles['content-inner']}>
          <ControlRadioGroup
            testid={`${testid}-radio-group`}
            options={cancelReasons || []}
            value={value}
            onChange={setValue}
          />
        </div>
      </div>
      <Button
        onClick={() => {
          if (value === null) {
            return;
          }
          const cancelReason = cancelReasons?.find((obj) => obj.id === value);
          const { name, generic_followup } = cancelReason || {};
          onNext({
            cancelReasonId: [value],
            cancelReasonText: name || null,
            cancelFreeTextHeader: generic_followup || null,
          });
        }}
        style={value ? 'default' : 'disabled'}
        testid={`${testid}-next`}
        size="medium"
        prominence="secondary"
        textPrimary="Continue to Cancel"
        className={pageStyles.confirm}
      />
    </div>
  );
}
